// extracted by mini-css-extract-plugin
export var list = "list-module--list---UWZ6";
export var list__wrapper = "list-module--list__wrapper--avp-6";
export var list__item = "list-module--list__item--24qAT";
export var list__itemMarker = "list-module--list__item-marker--yczeK";
export var footnotes__item = "list-module--footnotes__item--DMEzy";